jQuery(document).ready(function () {
	"use strict";
	var indicator = '<span class="theme-mega-indicator" aria-label="Toggle menu below"></span>';
	var parent = document.querySelectorAll("#mega-menu-wrap-primary #mega-menu-primary > li.mega-menu-megamenu > ul.mega-sub-menu li.mega-menu-column > ul.mega-sub-menu > li.mega-menu-item.widget_nav_menu h4.mega-block-title,#mega-menu-wrap-primary #mega-menu-primary li.mega-menu-item li.menu-item-has-children > a");
	for (var p = 0; p < parent.length; p++) {

		jQuery(indicator).insertAfter(parent[p]);
		jQuery(parent[p]).addClass("submenu-closed");
		//For navigations using headers
		jQuery(parent[p]).nextAll("div[class*='menu']").addClass("menu-closed");
		//For navigations with submenus
		jQuery(parent[p]).nextAll(".sub-menu").addClass("menu-closed");

		jQuery(parent[p]).click(function(e) {
			if(jQuery(this).hasClass('submenu-closed')){
         e.preventDefault();
				 jQuery(this).next('.theme-mega-indicator').click();
     	}
			else if(jQuery(this).hasClass('mega-block-title')){
				jQuery(this).next('.theme-mega-indicator').click();
			}
		});
	}

	var theme_indicator = document.querySelectorAll(".theme-mega-indicator");

	for (var i = 0; i < theme_indicator.length; i++) {

		jQuery(theme_indicator[i]).click(function(e) {

				//For navigations using headers
				jQuery(this).next("div[class*='menu']").toggleClass("menu-closed");
				//For navigations with submenus
				jQuery(this).next(".sub-menu").toggleClass("menu-closed");

				jQuery(this).prev().toggleClass("submenu-closed");
				jQuery(this).toggleClass("submenu-open");

		});

	}

	jQuery("body").click(function (e) {
		var windowwidth = window.innerWidth;
		if ((jQuery(".mega-toggle-on").length)&&(windowwidth > 991)) {
			//e.stopPropagation();
			jQuery("body").addClass("mega-menu-open");
		} else {
			jQuery("body").removeClass("mega-menu-open");
		}
	})


});
